import { FC } from 'react';
import { Link } from 'react-router-dom';

import { CuroAppRoute } from 'enums/curo/CuroAppRoute';
import useUtmSource from 'hooks/useUtmSource';

import styles from './FooterContent.module.scss';

interface IFooterContentProps {
  currentYear: number;
  companyName: string | null;
}

const FooterContent: FC<IFooterContentProps> = ({ companyName, currentYear }) => {
  const { setUtmQueryToURL } = useUtmSource();

  return (
    <div className={styles.footerContent}>
      <div className={styles.companyName}>
        © {currentYear} {companyName}
      </div>
      <div className={styles.documentsContainer}>
        <Link to={{ pathname: CuroAppRoute.TermsAndConditions, search: setUtmQueryToURL() }} target="_blank" className={styles.documentName}>
          Terms and Conditions
        </Link>
      </div>
    </div>
  );
};

export default FooterContent;
